import {copilot, users as usersShared} from '@cl/shared';
import adBuilderAgent from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/adBuilderAgent';
import creativeTemplatesManagerAgent from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/creativeTemplatesManagerAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {doesUserHaveRole} from 'common/src/modules/roles/utils/doesUserHaveRole';
import adBuilderSkill from 'common/src/modules/shared/copilot/skills/definitions/adBuilderSkill';
import creativeTemplatesManagerSkill from 'common/src/modules/shared/copilot/skills/definitions/creativeTemplatesManagerSkill';
import {registerSkill} from 'common/src/modules/shared/copilot/skills/skillRegistry';
import {RoleTypeName} from 'common/src/modules/users/users.types';
import {CLStore} from 'common/src/redux/store';

async function initializeCreativeTemplatesAgents(store: CLStore) {
  const isSkillsMode = isFlagEnabled(FeatureFlagKey.EnableCopilotSkills);

  if (!isSkillsMode) {
    copilot.registerAgent(creativeTemplatesManagerAgent(store));
  }

  registerSkill(creativeTemplatesManagerSkill(store));

  const userHasTemplateWriteRole = doesUserHaveRole(
    usersShared.userSubject.data,
    RoleTypeName.CreativeTemplatesWrite,
  );

  if (isFlagEnabled(FeatureFlagKey.EnableCopilotAdBuilderAgent) && userHasTemplateWriteRole) {
    if (!isSkillsMode) {
      copilot.registerAgent(await adBuilderAgent(store));
    }

    registerSkill(adBuilderSkill(store));
  }
}

export default initializeCreativeTemplatesAgents;
